// "mission.<key>" 로 부르는 문구. 값에 {name} 을 두면 t(key, { name }) 로 채운다.
// 미션 탭: 진행 링 상태(Mission.jsx) · 비행 상태 카드(DroneInfo.jsx) · Mission 카드(DroneControl.jsx)
// · 미션 종료 토스트(utils/missionStoppedToast.js) · mission_progress 라벨(utils/missionProgress.js).
const mission = {
  ko: {
    // Mission.jsx — 진행 링 아래 상태 문구(드론 progress 라벨이 없을 때)
    "status.flying": "비행 중",
    "status.poweredIdle": "전원 켜짐 · 대기",
    "status.powerOff": "전원 꺼짐",

    // utils/missionProgress.js — 드론 텔레메트리 mission_progress 라벨
    "progress.idle": "대기",
    "progress.uploaded": "업로드 완료",
    "progress.arming": "시동 중",
    "progress.takeoff": "이륙 중",
    "progress.moving": "이동 중",
    "progress.hovering": "호버링",
    "progress.capturing": "촬영 중",
    "progress.returning": "복귀 중",
    "progress.landing": "착륙 중",
    "progress.complete": "미션 완료",

    // utils/missionStoppedToast.js — 미션 종료/복귀 토스트
    "endToast.stopped": "미션이 종료되었습니다. 언제든 다시 시작할 수 있습니다.",
    "endToast.stopReturning": "미션을 정지했습니다. 드론이 복귀 중입니다.",
    "endToast.stopReady": "드론이 복귀했습니다. 다음 미션을 시작할 수 있습니다.",
    "endToast.completed": "미션을 성공적으로 완료했습니다.",
    "endToast.returning": "드론 복귀 중",

    // DroneInfo.jsx — 비행 상태 카드
    "info.stats": "비행 상태",
    "info.battery": "배터리",
    "info.gps": "GPS",
    "info.gps.good": "양호",
    "info.gps.poor": "불량",
    "info.gps.unknown": "알 수 없음",
    "info.flightTime": "비행 시간",
    "info.progress": "미션 진행",

    // DroneControl.jsx — Mission 카드 머리
    "control.title": "미션",
    "control.helpAria": "미션 도움말",
    "control.help.card":
      "전원을 켜고, 지도에서 셀을 고르거나 섹션을 불러온 뒤 업로드합니다. 드론이 경로를 확인하면 시작할 수 있습니다.",

    // DroneControl.jsx — 단계 칩
    "control.phase.flying": "비행 중",
    "control.phase.returning": "복귀 중",
    "control.phase.uploading": "업로드 확인 중",
    "control.phase.ready": "시작 가능",
    "control.phase.powerOff": "전원 꺼짐",
    "control.phase.idle": "대기",

    // DroneControl.jsx — 단계별 안내 문구
    "control.help.flying": "정지하면 드론이 복귀·착륙하고 촬영한 사진을 업로드합니다.",
    "control.help.uploading": "드론이 경로를 저장하고 확인을 보고하면 시작 버튼이 켜집니다.",
    "control.help.ready": "드론이 경로를 보관 중입니다. 시작하면 드론이 스스로 시동을 걸고 이륙합니다.",
    "control.help.idle": "업로드하면 드론이 경로를 저장하고 확인을 보고합니다. 확인되면 시작할 수 있습니다.",

    // DroneControl.jsx — 업로드/시작 버튼이 잠긴 이유
    "control.block.returning": "드론이 복귀 중입니다. 착륙할 때까지 기다리세요.",
    "control.block.noCells": "지도에서 셀을 고르거나 섹션을 불러오세요.",
    "control.block.altitude": "고도는 {min}~{max}m 사이여야 합니다.",
    "control.block.power": "먼저 드론 전원을 켜세요.",
    "control.block.gps": "GPS 신호가 약합니다 (현재 {now}). 신호가 양호로 바뀐 뒤 업로드하세요.",
    "control.block.gpsUnknown": "GPS 값을 아직 받지 못했습니다. 드론 연결을 확인한 뒤 업로드하세요.",
    "control.block.battery": "배터리 {now}% 로는 시작할 수 없습니다 ({min}% 이상 필요).",
    "control.block.batteryPending": "배터리 값을 아직 받지 못했습니다. 잠시 기다려 주세요.",
    "control.block.upload": "먼저 경로를 업로드하세요.",

    // DroneControl.jsx — 전원 / 비행 구역 / 비행 순서
    "control.power": "전원",
    "control.powerOn": "전원 켜기",
    "control.powerOff": "전원 끄기",
    "control.zone": "비행 구역",
    "control.zone.none": "선택 없음",
    "control.zone.manual": "직접 선택",
    "control.zone.summary": "{name} · {count}셀",
    "control.order": "비행 순서",
    "control.order.cell": "{n}번째 셀",

    // DroneControl.jsx — 섹션 불러오기 / 고도
    "control.section.load": "섹션 불러오기",
    "control.section.placeholder": "섹션 불러오기…",
    "control.section.empty": "저장된 섹션 없음",
    "control.section.option": "{name} · {count}셀 · {altitude}m",
    "control.altitude.title": "비행 고도 (m)",
    "control.altitude.decrease": "고도 낮추기",
    "control.altitude.increase": "고도 높이기",
    "control.altitude.input": "미션 고도 (m)",

    // DroneControl.jsx — 업로드 / 시작·정지 버튼
    "control.upload.aria": "드론에 미션 업로드",
    "control.upload.cancelAria": "미션 업로드 취소",
    "control.upload.confirming": "드론 확인 중…",
    "control.upload.confirmedCancel": "업로드 확인됨 · 취소",
    "control.upload.label": "경로 업로드",
    "control.start": "미션 시작",
    "control.stop": "미션 정지",

    // DroneControl.jsx — 토스트
    "control.toast.noDrone": "먼저 드론을 선택하세요.",
    "control.toast.powerRequiresStop": "전원을 바꾸려면 먼저 미션을 정지하세요.",
    "control.toast.powerRequiresDisarmed": "전원은 DISARMED 상태에서만 바꿀 수 있습니다.",
    "control.toast.powerUpdateFailed": "전원 상태를 변경하지 못했습니다.",
    "control.toast.uploadDone": "미션을 업로드했습니다. 시작할 수 있습니다.",
    "control.toast.uploadReturning": "드론이 복귀할 때까지 기다리세요.",
    "control.toast.uploadRequiresStop": "업로드하려면 먼저 미션을 정지하세요.",
    "control.toast.uploadRequiresCells": "먼저 지도에서 셀을 선택하세요.",
    "control.toast.altitudeRange": "고도는 {min}~{max}m 사이여야 합니다.",
    "control.toast.uploadRequiresPower": "업로드하려면 먼저 전원을 켜세요.",
    "control.toast.noRoute": "이 농장의 경로를 찾을 수 없습니다.",
    "control.toast.buildWaypointsFailed": "웨이포인트를 생성하지 못했습니다.",
    "control.toast.saveWaypointsFailed": "웨이포인트를 저장하지 못했습니다.",
    "control.toast.uploadTimeout": "드론이 업로드에 응답하지 않았습니다. GPS 상태와 전원을 확인한 뒤 다시 업로드하세요.",
    "control.toast.uploadFailed": "미션을 업로드하지 못했습니다.",
    "control.toast.cancelRequiresStop": "취소하려면 먼저 미션을 정지하세요.",
    "control.toast.cancelUploadFailed": "미션 업로드를 취소하지 못했습니다.",
    "control.toast.startRequiresPower": "시작하려면 먼저 전원을 켜세요.",
    "control.toast.startRequiresBattery": "배터리가 {min}% 이상이어야 시작할 수 있습니다 (현재 {now}%).",
    "control.toast.gpsNotReady": "GPS가 비행 준비되지 않았습니다. 시작 전에 GPS 상태를 확인하세요.",
    "control.toast.gpsCheck": "GPS 상태를 확인하세요.",
    "control.toast.startRequiresUpload": "먼저 미션을 업로드하세요. 드론이 경로를 확인하지 않았습니다.",
    "control.toast.startRequiresWaypoints": "웨이포인트가 없습니다. 시작 전에 셀을 선택해 경로를 만드세요.",
    "control.toast.startRequiresUploadedWaypoints": "웨이포인트가 없습니다. 시작 전에 미션을 업로드하세요.",
    "control.toast.batteryLowServer": "배터리가 {min}% 이상이어야 시작할 수 있습니다.",
    "control.toast.notUploadedServer": "드론이 미션 업로드를 확인하지 않았습니다. 다시 업로드하세요.",
    "control.toast.notArmed": "드론이 ARMED 상태가 아닙니다. 시작 전에 미션을 다시 업로드하세요.",
    "control.toast.missionStatusFailed": "미션 상태를 변경하지 못했습니다.",
    "control.toast.loadBusyCancelFirst": "먼저 업로드를 취소하세요.",
    "control.toast.loadBusy": "지금은 구역을 바꿀 수 없습니다.",
    "control.toast.loadFailed": "구역을 불러오지 못했습니다.",
  },
  en: {
    "status.flying": "Flying",
    "status.poweredIdle": "Powered on · Standby",
    "status.powerOff": "Power off",

    "progress.idle": "Idle",
    "progress.uploaded": "Uploaded",
    "progress.arming": "Arming",
    "progress.takeoff": "Taking off",
    "progress.moving": "Moving",
    "progress.hovering": "Hovering",
    "progress.capturing": "Capturing",
    "progress.returning": "Returning",
    "progress.landing": "Landing",
    "progress.complete": "Mission complete",

    "endToast.stopped": "Mission ended. Ready whenever you are.",
    "endToast.stopReturning": "Mission stopped. Drone is returning home.",
    "endToast.stopReady": "Drone returned home. Ready for next mission.",
    "endToast.completed": "Mission completed successfully.",
    "endToast.returning": "Drone returning home",

    "info.stats": "Flight status",
    "info.battery": "Battery",
    "info.gps": "GPS",
    "info.gps.good": "Good",
    "info.gps.poor": "Poor",
    "info.gps.unknown": "Unknown",
    "info.flightTime": "Flight time",
    "info.progress": "Mission progress",

    "control.title": "Mission",
    "control.helpAria": "Mission help",
    "control.help.card":
      "Turn on power, select cells on the map or load a section, then upload. You can start once the drone confirms the route.",

    "control.phase.flying": "Flying",
    "control.phase.returning": "Returning",
    "control.phase.uploading": "Confirming upload",
    "control.phase.ready": "Ready to start",
    "control.phase.powerOff": "Power off",
    "control.phase.idle": "Standby",

    "control.help.flying": "Stopping makes the drone return, land, and upload the captured photos.",
    "control.help.uploading": "The Start button turns on once the drone saves the route and reports confirmation.",
    "control.help.ready": "The drone is holding the route. On start, it arms itself and takes off.",
    "control.help.idle": "Uploading sends the route to the drone, which saves it and reports confirmation. You can start once confirmed.",

    "control.block.returning": "Drone is returning home. Wait until it lands.",
    "control.block.noCells": "Select cells on the map or load a section.",
    "control.block.altitude": "Altitude must be between {min} and {max} m.",
    "control.block.power": "Turn on the drone power first.",
    "control.block.gps": "GPS signal is weak (now {now}). Upload once the signal is Good.",
    "control.block.gpsUnknown": "No GPS reading yet. Check the drone connection, then upload.",
    "control.block.battery": "Cannot start at {now}% battery ({min}% or more required).",
    "control.block.batteryPending": "No battery reading yet. Please wait a moment.",
    "control.block.upload": "Upload the route first.",

    "control.power": "Power",
    "control.powerOn": "Turn power on",
    "control.powerOff": "Turn power off",
    "control.zone": "Flight zone",
    "control.zone.none": "No selection",
    "control.zone.manual": "Manual selection",
    "control.zone.summary": (p) => `${p.name} · ${p.count} ${Number(p.count) === 1 ? "cell" : "cells"}`,
    "control.order": "Flight order",
    "control.order.cell": "Cell {n}",

    "control.section.load": "Load section",
    "control.section.placeholder": "Load section…",
    "control.section.empty": "No saved sections",
    "control.section.option": (p) =>
      `${p.name} · ${p.count} ${Number(p.count) === 1 ? "cell" : "cells"} · ${p.altitude}m`,
    "control.altitude.title": "Flight altitude (m)",
    "control.altitude.decrease": "Decrease altitude",
    "control.altitude.increase": "Increase altitude",
    "control.altitude.input": "Mission altitude in meters",

    "control.upload.aria": "Upload mission to drone",
    "control.upload.cancelAria": "Cancel mission upload",
    "control.upload.confirming": "Waiting for drone…",
    "control.upload.confirmedCancel": "Upload confirmed · Cancel",
    "control.upload.label": "Upload route",
    "control.start": "Start mission",
    "control.stop": "Stop mission",

    "control.toast.noDrone": "Please select a drone first.",
    "control.toast.powerRequiresStop": "Stop the mission before changing power.",
    "control.toast.powerRequiresDisarmed": "Power can only be changed in DISARMED state.",
    "control.toast.powerUpdateFailed": "Failed to update power status",
    "control.toast.uploadDone": "Mission uploaded. Ready to start.",
    "control.toast.uploadReturning": "Wait until the drone has returned home.",
    "control.toast.uploadRequiresStop": "Stop the mission before uploading.",
    "control.toast.uploadRequiresCells": "Select cells on the map first.",
    "control.toast.altitudeRange": "Altitude must be between {min} and {max} m.",
    "control.toast.uploadRequiresPower": "Turn on power before uploading.",
    "control.toast.noRoute": "No route found for this farm.",
    "control.toast.buildWaypointsFailed": "Failed to generate waypoints.",
    "control.toast.saveWaypointsFailed": "Failed to save waypoints.",
    "control.toast.uploadTimeout": "Drone did not respond to the upload. Check GPS status and power, then upload again.",
    "control.toast.uploadFailed": "Failed to upload mission.",
    "control.toast.cancelRequiresStop": "Stop the mission before cancelling.",
    "control.toast.cancelUploadFailed": "Failed to cancel mission upload",
    "control.toast.startRequiresPower": "Turn on power before starting.",
    "control.toast.startRequiresBattery": "Battery must be at least {min}% to start (now {now}%).",
    "control.toast.gpsNotReady": "GPS is not ready for flight. Check the GPS status before starting.",
    "control.toast.gpsCheck": "Please check the GPS status.",
    "control.toast.startRequiresUpload": "Upload the mission first. The drone has not confirmed a route.",
    "control.toast.startRequiresWaypoints": "No waypoints found. Please create a route by selecting cells before starting.",
    "control.toast.startRequiresUploadedWaypoints": "No waypoints found. Please upload a mission before starting.",
    "control.toast.batteryLowServer": "Battery must be at least {min}% to start.",
    "control.toast.notUploadedServer": "Drone has not confirmed the mission upload. Please upload again.",
    "control.toast.notArmed": "Drone is not ARMED. Please upload the mission again before starting.",
    "control.toast.missionStatusFailed": "Failed to change mission status.",
    "control.toast.loadBusyCancelFirst": "Cancel the upload first.",
    "control.toast.loadBusy": "The zone cannot be changed right now.",
    "control.toast.loadFailed": "Failed to load the zone.",
  },
};

export default mission;
